<mat-legacy-card-title
  mat-legacy-dialog-title
  class="justify-content-between align-items-center d-flex mb-0"
>
  <div>
    <span style="align-items: center; display: flex">
      <mat-icon *ngIf="icon" class="mr-2">{{ icon }}</mat-icon>
      <span>{{ title }} </span></span
    >
  </div>
  <div>
    <button
      *ngIf="isSecondaryButtonShow"
      type="button"
      mat-stroked-button
      id="add-new"
      style="margin-right: 8px"
      [disabled]="!isSecondaryButtonEnabled"
      (click)="onSecondaryButton()"
    >
      {{ secondaryButtonText }}</button
    ><button
      *ngIf="isTertiaryButtonShow"
      type="button"
      mat-stroked-button
      id="download-members"
      style="margin-right: 8px"
      [disabled]="!isTertiaryButtonEnabled"
      (click)="onTertiaryButton()"
    >
      {{ tertiaryButtonText }}</button
    ><button
      *ngIf="isSideButtonShow"
      type="button"
      mat-stroked-button
      id="add-new"
      [disabled]="!isSideButtonEnabled"
      (click)="onSideButton()"
    >
      {{ sideButtonText }}
    </button>
  </div></mat-legacy-card-title
>
<mat-card-subtitle>{{ subTitle }}</mat-card-subtitle>
<mat-divider style="margin-left: -16px; margin-right: -16px"></mat-divider>
